import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody
} from "reactstrap";
import CountUp from 'react-countup';

//import action
import { getChartsData as onGetChartsData, viewProfile } from "../../../store/actions";
import { onDashboardAnalytic } from "helpers/backend_api_helper";

// Pages Components
import WelcomeComp from "./WelcomeComp";

//Import Breadcrumb
import Breadcrumbs from "../../../components/_Common/Breadcrumb";
import WalletBalance from "./wallet-balance";


//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import MonthlyEarning from "./MonthlyEarning";

const Dashboard = props => {

  const { chartsData, state } = useSelector(state => ({
    chartsData: state.Dashboard.chartsData,
    state: state

  }));
const [profileData, setProfileData] = useState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(onGetChartsData("yearly"));
    dispatch(viewProfile('auth/me', (data) => {
      setProfileData(data?.data)
    }));
  }, [dispatch]);

  // meta title
  document.title = "Dashboard | Institute on Governance - Admin & Dashboard";
  const [analyticData, setAnalyticData] = useState();

  const reports = [
    { key: 'total_batchs', title: "Total Batches", iconClass: "bx bx-group", description: analyticData?.total_batchs || "0" },
    {key: 'total_surveys', title: "Total Surveys", iconClass: "bx bxs-data", description: analyticData?.total_surveys || "0" },
    {
      key: 'total_surveys_pending',
      title: "Pending Surveys",
      iconClass: "bx bx-hourglass",
      description: analyticData?.total_surveys_pending || "0",
    },
    {
      key: 'total_surveys_inprogress',
      title: "In-Progress Surveys",
      iconClass: "bx bx-line-chart",
      description: analyticData?.total_surveys_inprogress || "0",
    },
    {
      key: 'total_surveys_complete',
      title: "Complete Surveys",
      iconClass: "bx bx-check",
      description: analyticData?.total_surveys_complete || "0",
    },
  ];

  const getAnalyticData = async(date) => {
    try {
      const analyticData = await onDashboardAnalytic(date);
      if(analyticData?.status_code == '200'){
        setAnalyticData(analyticData?.data)
      }
    } catch (error) {
      
    }
  }

  useEffect(() => {
    const date = new Date();
    const monthNumber = date.getMonth() + 1; 
    const currentYear = date.getFullYear();
    getAnalyticData(`/${monthNumber}/${currentYear}`)
  },[])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="p-0">
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          /> */}
          <Row className="report-for-box">
            {/* Reports Render */}
            {reports.map((report, key) => (
              <Col md="3" key={"_col_" + key}>
                <Card className="mini-stats-wid">
                  <div className="monthly-earning-chart">
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">
                          {report.title}
                        </p>
                        <h4 className="mb-0"><CountUp end={report.description} /></h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i
                            className={
                              "bx " + report.iconClass + " font-size-24"
                            }
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          <Row>
            <Col xl="12">
              <WelcomeComp profileData = {profileData} />
            </Col>
            <Col md="12">
              <WalletBalance getAnalyticData={getAnalyticData}  analyticData = {analyticData} dataColors='["--bs-primary", "--bs-warning", "--bs-info"]' />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
